// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    display: inline-block;
    padding: 0 16px;
    height: 100%;
    line-height: 36px;
}

    .button.mdc-icon-button {
        width: 40px;
        height: 40px;
        padding: 0px;
        line-height: 40px;
    }

    .button.mdc-icon-button .mat-icon {
        line-height: 24px;
    }
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/button/button.control.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB","sourcesContent":[".button {\n    display: inline-block;\n    padding: 0 16px;\n    height: 100%;\n    line-height: 36px;\n}\n\n    .button.mdc-icon-button {\n        width: 40px;\n        height: 40px;\n        padding: 0px;\n        line-height: 40px;\n    }\n\n    .button.mdc-icon-button .mat-icon {\n        line-height: 24px;\n    }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
